import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";
import 'velocity-animate';


/**
 * This controller is a good spot to initialize any javascript comonents
 * that might need setup for demo in the UI Docs.
 */

@Options({
    template: false,
    el: "body",
    ui: {
        overlayNav: '.overlay-nav',
        overlayContent: '.overlay-content',
        navigation: '.primary-nav',
        toggleNav: '.nav-trigger'
    }
})
export default class ViewController extends Marionette.View<Backbone.Model>{
    constructor() {
        super();
    }

    onRender() {
        // Temp

        //inizialize navigation and content layers
        this.layerInit();
        $(window).on('resize', function(){
            window.requestAnimationFrame(this.layerInit);
        }.bind(this));
    }

    //open/close the menu and cover layers
    // toggleNav.on('click', function(){
    @on("click @ui.toggleNav")
    toggleNav(e) {
        let overlayNav = $('.overlay-nav'),
        overlayContent = $('.overlay-content'),
        navigation = $('.primary-nav'),
        toggleNav = $('.nav-trigger');

        e.preventDefault();

        if(!toggleNav.hasClass('close-nav')) {
            //it means navigation is not visible yet - open it and animate navigation layer
            toggleNav.addClass('close-nav');

            overlayNav.children('span').velocity({
                translateZ: 0,
                scaleX: 1,
                scaleY: 1,
            }, 500, 'easeInCubic', function(){
                navigation.addClass('fade-in');
            });
        } else {
            //navigation is open - close it and remove navigation layer
            toggleNav.removeClass('close-nav');

            overlayContent.children('span').velocity({
                translateZ: 0,
                scaleX: 1,
                scaleY: 1,
            }, 500, 'easeInCubic', function(){
                navigation.removeClass('fade-in');

                overlayNav.children('span').velocity({
                    translateZ: 0,
                    scaleX: 0,
                    scaleY: 0,
                }, 0);

                overlayContent.addClass('is-hidden').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
                    overlayContent.children('span').velocity({
                        translateZ: 0,
                        scaleX: 0,
                        scaleY: 0,
                    }, 0, function(){overlayContent.removeClass('is-hidden')});
                });
                if($('html').hasClass('no-csstransitions')) {
                    overlayContent.children('span').velocity({
                        translateZ: 0,
                        scaleX: 0,
                        scaleY: 0,
                    }, 0, function(){overlayContent.removeClass('is-hidden')});
                }
            });
        }
    }

    layerInit() {
        var diameterValue = (Math.sqrt( Math.pow($(window).height(), 2) + Math.pow($(window).width(), 2))*2);
        let overlayNav = $('.overlay-nav'),
        overlayContent = $('.overlay-content');

        overlayNav.children('span').velocity({
            scaleX: 0,
            scaleY: 0,
            translateZ: 0,
        }, 50).velocity({
            height : diameterValue+'px',
            width : diameterValue+'px',
            top : -(diameterValue/2)+'px',
            left : -(diameterValue/2)+'px',
        }, 0);

        overlayContent.children('span').velocity({
            scaleX: 0,
            scaleY: 0,
            translateZ: 0,
        }, 50).velocity({
            height : diameterValue+'px',
            width : diameterValue+'px',
            top : -(diameterValue/2)+'px',
            left : -(diameterValue/2)+'px',
        }, 0);
    }
}
